import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'
import AuthContext from '../../../msal'

class Page500 extends Component {
  constructor(props) {
    super(props)
    this.message = props.message
    this.state = {
      counter: 5
    }
  }

  componentDidMount() {
    this.handleClickLogOut()
  }

  handleClickLogOut() {
    this.props.msal.signOut().then(() => window.location.replace('/'))
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <span className="clearfix">
                <h4>:( Parece que hay un error con tu sesión </h4>
                <p className="text-muted float-left">{`Seras redireccionado al login...`}</p>
              </span>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

Page500.contextType = AuthContext
export default Page500
